import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/equipment_dispatches',
  component: Management,
  redirect: '/equipment_dispatches/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/equipment_dispatches/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listEquipmentDispatches
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/equipment_dispatches/ListTable'),
          meta: {
            auth: Auth.listEquipmentDispatches,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/equipment_dispatches/New'),
      meta: {
        auth: Auth.createEquipmentDispatch
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/equipment_dispatches/Edit'),
      meta: {
        auth: Auth.updateEquipmentDispatch
      }
    },
    // 编辑
    {
      path: ':id/active',
      component: () => import('@/views/equipment_dispatches/Active'),
      meta: {
        auth: Auth.updateEquipmentDispatch
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/equipment_dispatches/DetailLayout'),
      meta: {
        auth: Auth.showEquipmentDispatch
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/equipment_dispatches/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showEquipmentDispatch
          }
        }
      ]
    }
  ]
}
